// src/components/Header.js
import React, { useEffect, useState } from "react";
import phoneicon from "../assets/images/icon-phone.svg";
import mailicon from "../assets/images/icon-mail.svg";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";

export default function Header() {
  const [openPopup, setOpenPopup] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
const [isSticky, setIsSticky] = useState(false);

 // Sticky header on scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Topbar Section Start */}
      <div className="topbar">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-9 col-md-12">
              {/* Topbar Contact Information Start */}
              <div className="topbar-contact-info">
                <ul>
                  <li>
                    <a href="tel:09000666889">
                      <img loading="lazy" src={phoneicon} alt="phone icon" /> 090006 66889
                    </a>
                  </li>
                  <li>
                    <a href="mailto:brightlifephysio@gmail.com">
                      <img loading="lazy" src={mailicon} alt="mail icon" />{" "}
                      brightlifephysio@gmail.com
                    </a>
                  </li>
                </ul>
              </div>
              {/* Topbar Contact Information End */}
            </div>

            <div className="col-lg-3 col-md-0">
              {/* Topbar Social Links Start */}
              <div className="topbar-social-links">
                <ul>
                  <li>
                    <a href="https://www.facebook.com/BrightlifePhysio" target="_blank" aria-label="Facebook">
                      <i className="fa-brands fa-facebook-f" />
                    </a>
                  </li>
               
                  <li>
                    <a href="https://www.instagram.com/brightlife_physiopoint/" target="_blank" aria-label="Instagram">
                      <i className="fa-brands fa-instagram" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/@BrightLifePhysioPoint" target="_blank" aria-label="YouTube">
                      <i className="fa-brands fa-youtube" />
                    </a>
                  </li>
                </ul>
              </div>
              {/* Topbar Social Links End */}
            </div>
          </div>
        </div>
      </div>
      {/* Topbar Section End */}

      {/* Header Start */}
      <header className={`main-header ${isSticky ? "sticky" : ""}`}>
          <nav className="navbar navbar-expand-lg">
            <div className="container">
              {/* Logo Start */}
              <a className="navbar-brand" href="/">
                <img loading="lazy" src={logo} alt="Logo" />
              </a>
              {/* Logo End */}

              {/* Main Menu Start */}
              <div className={`navbar-collapse main-menu ${menuOpen ? "show" : ""}`}>
                <div className="nav-menu-wrapper">
                  <ul className="navbar-nav mr-auto" id="menu">
                    <li className="nav-item">
                      <Link className="nav-link" to="/"  onClick={() => setMenuOpen(false)}>
                        Home
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/about"  onClick={() => setMenuOpen(false)}>
                        About Us
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/services"  onClick={() => setMenuOpen(false)}>
                        Services
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/therapists"  onClick={() => setMenuOpen(false)}>
                        Our Therapists
                      </Link>
                    </li>
                      <li className="nav-item">
                      <Link className="nav-link" to="/gallery"  onClick={() => setMenuOpen(false)}>
                        Gallery
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/contact"  onClick={() => setMenuOpen(false)}>
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </div>

                {/* Let’s Start Button Start */}
                <div className="header-btn d-inline-flex">
                  {/* <Link to="/appointment" className="btn-default">
                    Book Appointment
                  </Link> */}
                  <a
                    href="https://wa.me/919000666889?text=Hi%20BrightLife%20Physio%20Point,%20I%20would%20like%20to%20book%20an%20appointment."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-default mobile-cta"
                  >
                    {" "}
                    Book Appointment
                  </a>
                </div>
                {/* Let’s Start Button End */}
              </div>
              {/* Main Menu End */}

             <div className="header-actions">
  {/* Mobile Appointment Icon */}
  <a
    href="https://wa.me/919000666889?text=Hi%20BrightLife%20Physio%20Point,%20I%20would%20like%20to%20book%20an%20appointment."
    target="_blank"
    rel="noopener noreferrer"
    className="header-appointment-icon"
    aria-label="Book appointment on WhatsApp"
  >
    <i className="fab fa-whatsapp"></i>
  </a>

  {/* Hamburger Toggle */}
  <button
    className={`navbar-toggler ${menuOpen ? "active" : ""}`}
    onClick={() => setMenuOpen(!menuOpen)}
    aria-label="Toggle menu"
  >
    <span />
    <span />
    <span />
  </button>
</div>


            </div>
          </nav>
          <div className="responsive-menu" />
      </header>
      {/* Header End */}
    </>
  );
}
